// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__SbPYN","col":"CardReaderDesc_col__3C1sb","label":"CardReaderDesc_label__PCE4E"};